/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPRemote,
  ExternalMCPRemote$inboundSchema,
} from "./externalmcpremote.js";
import {
  ExternalMCPTool,
  ExternalMCPTool$inboundSchema,
} from "./externalmcptool.js";

/**
 * An MCP server from an external registry
 */
export type ExternalMCPServer = {
  /**
   * Description of what the server does
   */
  description: string;
  /**
   * URL to the server's icon
   */
  iconUrl?: string | undefined;
  /**
   * ID of the attached MCP server backing this server
   */
  mcpServerId?: string | undefined;
  /**
   * Opaque metadata from the registry
   */
  meta?: any | undefined;
  /**
   * ID of the external MCP registry this server came from
   */
  registryId?: string | undefined;
  /**
   * Server specifier used to look up in the registry (e.g., 'io.github.user/server')
   */
  registrySpecifier: string;
  /**
   * Available remote endpoints for the server
   */
  remotes?: Array<ExternalMCPRemote> | undefined;
  /**
   * Display name for the server
   */
  title?: string | undefined;
  /**
   * Tools available on the server
   */
  tools?: Array<ExternalMCPTool> | undefined;
  /**
   * ID of the attached toolset backing this server
   */
  toolsetId?: string | undefined;
  /**
   * Semantic version of the server
   */
  version: string;
};

/** @internal */
export const ExternalMCPServer$inboundSchema: z.ZodMiniType<
  ExternalMCPServer,
  unknown
> = z.pipe(
  z.object({
    description: z.string(),
    icon_url: z.optional(z.string()),
    mcp_server_id: z.optional(z.string()),
    meta: z.optional(z.any()),
    registry_id: z.optional(z.string()),
    registry_specifier: z.string(),
    remotes: z.optional(z.array(ExternalMCPRemote$inboundSchema)),
    title: z.optional(z.string()),
    tools: z.optional(z.array(ExternalMCPTool$inboundSchema)),
    toolset_id: z.optional(z.string()),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "icon_url": "iconUrl",
      "mcp_server_id": "mcpServerId",
      "registry_id": "registryId",
      "registry_specifier": "registrySpecifier",
      "toolset_id": "toolsetId",
    });
  }),
);

export function externalMCPServerFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPServer' from JSON`,
  );
}
